/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CalorificCalorificWrite,
  CalorificJsonldCalorificRead,
  CalorificJsonldCalorificWrite
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type calorific_postResponse201 = {
  data: CalorificJsonldCalorificRead
  status: 201
}

export type calorific_postResponse400 = {
  data: void
  status: 400
}

export type calorific_postResponse422 = {
  data: void
  status: 422
}

export type calorific_postResponseSuccess = (calorific_postResponse201) & {
  headers: Headers;
};
export type calorific_postResponseError = (calorific_postResponse400 | calorific_postResponse422) & {
  headers: Headers;
};

export type calorific_postResponse = (calorific_postResponseSuccess | calorific_postResponseError)

export const getCalorificPostUrl = () => {




  return `/api/calorific`
}

/**
 * Creates a Calorific resource.
 * @summary Creates a Calorific resource.
 */
export const calorific_post = async (calorificPostBody: CalorificJsonldCalorificWrite | CalorificCalorificWrite, options?: RequestInit): Promise<calorific_postResponse> => {

  return apiCatalog<calorific_postResponse>(getCalorificPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(calorificPostBody)
  }
);}





export const getCalorificPostMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calorific_post>>, TError,{data: CalorificJsonldCalorificWrite | CalorificCalorificWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof calorific_post>>, TError,{data: CalorificJsonldCalorificWrite | CalorificCalorificWrite}, TContext> => {

const mutationKey = ['calorificPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calorific_post>>, {data: CalorificJsonldCalorificWrite | CalorificCalorificWrite}> = (props) => {
          const {data} = props ?? {};

          return  calorific_post(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CalorificPostMutationResult = NonNullable<Awaited<ReturnType<typeof calorific_post>>>
    export type CalorificPostMutationBody = CalorificJsonldCalorificWrite | CalorificCalorificWrite
    export type CalorificPostMutationError = void

    /**
 * @summary Creates a Calorific resource.
 */
export const useCalorificPost = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calorific_post>>, TError,{data: CalorificJsonldCalorificWrite | CalorificCalorificWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calorific_post>>,
        TError,
        {data: CalorificJsonldCalorificWrite | CalorificCalorificWrite},
        TContext
      > => {
      return useMutation(getCalorificPostMutationOptions(options), queryClient);
    }
    export type calorific_patchResponse200 = {
  data: CalorificJsonldCalorificRead
  status: 200
}

export type calorific_patchResponse400 = {
  data: void
  status: 400
}

export type calorific_patchResponse404 = {
  data: void
  status: 404
}

export type calorific_patchResponse422 = {
  data: void
  status: 422
}

export type calorific_patchResponseSuccess = (calorific_patchResponse200) & {
  headers: Headers;
};
export type calorific_patchResponseError = (calorific_patchResponse400 | calorific_patchResponse404 | calorific_patchResponse422) & {
  headers: Headers;
};

export type calorific_patchResponse = (calorific_patchResponseSuccess | calorific_patchResponseError)

export const getCalorificPatchUrl = (id: string,) => {




  return `/api/calorific/${id}`
}

/**
 * Updates the Calorific resource.
 * @summary Updates the Calorific resource.
 */
export const calorific_patch = async (id: string,
    calorificCalorificWrite: CalorificCalorificWrite, options?: RequestInit): Promise<calorific_patchResponse> => {

  return apiCatalog<calorific_patchResponse>(getCalorificPatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/merge-patch+json', ...options?.headers },
    body: JSON.stringify(calorificCalorificWrite)
  }
);}





export const getCalorificPatchMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calorific_patch>>, TError,{id: string;data: CalorificCalorificWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof calorific_patch>>, TError,{id: string;data: CalorificCalorificWrite}, TContext> => {

const mutationKey = ['calorificPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calorific_patch>>, {id: string;data: CalorificCalorificWrite}> = (props) => {
          const {id,data} = props ?? {};

          return  calorific_patch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CalorificPatchMutationResult = NonNullable<Awaited<ReturnType<typeof calorific_patch>>>
    export type CalorificPatchMutationBody = CalorificCalorificWrite
    export type CalorificPatchMutationError = void

    /**
 * @summary Updates the Calorific resource.
 */
export const useCalorificPatch = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calorific_patch>>, TError,{id: string;data: CalorificCalorificWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calorific_patch>>,
        TError,
        {id: string;data: CalorificCalorificWrite},
        TContext
      > => {
      return useMutation(getCalorificPatchMutationOptions(options), queryClient);
    }
    export type calorific_getResponse200 = {
  data: CalorificJsonldCalorificRead
  status: 200
}

export type calorific_getResponse404 = {
  data: void
  status: 404
}

export type calorific_getResponseSuccess = (calorific_getResponse200) & {
  headers: Headers;
};
export type calorific_getResponseError = (calorific_getResponse404) & {
  headers: Headers;
};

export type calorific_getResponse = (calorific_getResponseSuccess | calorific_getResponseError)

export const getCalorificGetUrl = (id: string,) => {




  return `/api/calorifics/${id}`
}

/**
 * Retrieves a Calorific resource.
 * @summary Retrieves a Calorific resource.
 */
export const calorific_get = async (id: string, options?: RequestInit): Promise<calorific_getResponse> => {

  return apiCatalog<calorific_getResponse>(getCalorificGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCalorificGetQueryKey = (id: string,) => {
    return [
    `/api/calorifics/${id}`
    ] as const;
    }


export const getCalorificGetQueryOptions = <TData = Awaited<ReturnType<typeof calorific_get>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calorific_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalorificGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof calorific_get>>> = ({ signal }) => calorific_get(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calorific_get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalorificGetQueryResult = NonNullable<Awaited<ReturnType<typeof calorific_get>>>
export type CalorificGetQueryError = void


export function useCalorificGet<TData = Awaited<ReturnType<typeof calorific_get>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calorific_get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calorific_get>>,
          TError,
          Awaited<ReturnType<typeof calorific_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalorificGet<TData = Awaited<ReturnType<typeof calorific_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calorific_get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calorific_get>>,
          TError,
          Awaited<ReturnType<typeof calorific_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalorificGet<TData = Awaited<ReturnType<typeof calorific_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calorific_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Calorific resource.
 */

export function useCalorificGet<TData = Awaited<ReturnType<typeof calorific_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calorific_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalorificGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






